
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question as QuestionEntity} from '@/lib/Question';

    @Component({
    })
    export default class SubQuestion extends Vue {
        @Prop() public question?: QuestionEntity;
        mounted(){
            if (!this.question.children.length) {
                const children = this.$store.state.questions.filter((question: QuestionEntity) => question.parentId === this.question.id);
                children.forEach((child: QuestionEntity) => this.question.children.push(child));
            }
        }
        beforeCreate () {
            this.$options.components.QuestionView = require('@/components/Question.vue').default;
        }


    }
